import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-card d-flex" }
const _hoisted_2 = { class: "avatar rounded-circle border border-1 mt-2 h-50 ratio ratio-1x1" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card w-100" }
const _hoisted_5 = { class: "card-body d-flex p-0 m-2 overflow-hidden align-items-center" }
const _hoisted_6 = { class: "card-text ms-2 d-flex flex-grow-1 justify-content-center" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "d-flex align-items-center me-2" }
const _hoisted_9 = { class: "d-flex flex-column text-center lh-1 text-nowrap" }
const _hoisted_10 = { class: "fw-bold mb-0" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "card-footer text-center small" }
const _hoisted_13 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.profilePictureUrl,
        alt: _ctx.userData.username,
        class: "rounded-circle img-fluid gtr-avatar-bg"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_rank_icon, {
                "icon-class": _ctx.userData.rankIconClass,
                "extra-class": "fa-lg fa-fw"
              }, null, 8, ["icon-class"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userData.nickname), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.userData.username), 1)
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ms-2" }, [
              _createElementVNode("i", { class: "fas fa-lg fa-fw" })
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.userInitialDate), 1)
      ])
    ])
  ]))
}